// extracted by mini-css-extract-plugin
export var entityChip = "_sq-0";
export var entityChipMissing = "_sq-1";